import declare from "dojo/_base/declare";
import AffectedItemsGroupController from "./AffectedItemsGroupController";
import FetchAdditionalImpactedItemsController from "./FetchAdditionalImpactedItemsController";

const FetchAdditionalImpactedItemsGroupController = declare([AffectedItemsGroupController, FetchAdditionalImpactedItemsController], {
});

export = FetchAdditionalImpactedItemsGroupController;